import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface LoadingState {
  [key: string]: boolean;
}

export enum LoadingType {
  ApplicationUpdate = 'ApplicationUpdate',
  BorrowerUpdate = 'BorrowerUpdate',
  GetData = 'GetData',
  RunUnderwriting = 'RunUnderwriting',
  CodeVerification = 'CodeVerification',
  AccountSettingUpdating = 'AccountSettingUpdating',
  DashboardPageUpdating = 'DashboardPageUpdating',
  AccountSettingsProcessing = 'AccountSettingsProcessing',
  CreateIntermediary = 'CreateIntermediary',
  RequiredInformationUpdating = 'RequiredInformationUpdating',
  GetBankAccounts = 'GetBankAccounts',
}

const initialState: LoadingState = {};

const loading = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setLoadingState(state: LoadingState, { payload }: PayloadAction<{ type: string; loading: boolean }>) {
      state[payload.type] = payload.loading;
    },
  },
});

export const { setLoadingState } = loading.actions;

export default loading.reducer;
